import React, { useEffect, useState, useCallback } from 'react';
import {
  Box,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  Modal,
  IconButton,
  DialogContent,
  TablePagination,Button
} from '@mui/material';
import {
  BootstrapDialog,
  BootstrapDialogTitle,
  Breadcrumb,
  CTSinput,
  CTSRinput,
  StyledTableCell,
  StyledTableRow,
} from '../../reusableComponent/Reusables';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { Print } from '@mui/icons-material';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import productionentryService from '../../../services/productionentry.Service';
import plantMasterService from '../../../services/masters/plantMaster.Service';
import Sales_reportSerivces from '../../../services/report/Sales_report.Serivces';

const printStyles = `
  /* Hide .print-header-info by default (on screen) */
  .print-header-info {
    display: none;
  }

  @media print {
    .print-header-info {
      display: block !important;
      margin-bottom: 10px;
    }

    body * {
      visibility: hidden;
    }

    .printable-area, .printable-area * {
      visibility: visible;
    }

    .printable-area {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      overflow: visible !important;
      height: auto !important;
      max-height: none !important;
    }

    .printable-table {
      width: 100% !important;
      border-collapse: collapse !important;
      overflow: visible !important;
    }

    .printable-table thead {
      display: table-header-group;
      
    }

    .printable-table tbody {
      display: table-row-group;
    
    }

    .printable-table th {
      font-size: 15px !important;
    }

    .printable-table td {
      font-size: 12px !important;
    }

    .MuiPaper-root,
    .MuiTableContainer-root {
      overflow: visible !important;
      max-height: none !important;
      box-shadow: none !important;
    }

    .no-print {
      display: none !important;
    }
  }
`;


const Salesreport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state || null;

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details || '{}');
  const userInfo = userD.result?.userInfo || {};
  const depot_id = userInfo.depot_id;
  const plant_id = userInfo.plant_id;

  const [successMessage, setSuccessMessage] = useState('');
  const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [plant, setPlant] = useState([]);
  const [info, setInfo] = useState([]);
  const [openDetail, setDetail] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const {
    control,
    watch,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      entry_date_from: editData?.entry_date ? dayjs(editData.entry_date).format('YYYY-MM-DD') : '',
      entry_date_to: editData?.entry_date ? dayjs(editData.entry_date).format('YYYY-MM-DD') : '',
    },
  });

  const entryDateFrom = watch('entry_date_from');
  const entryDateTo = watch('entry_date_to');

const getTotalQtyFromTableDetails = (tableDetails) => {
  if (!tableDetails) return 0;
  try {
    const detailsArray = JSON.parse(tableDetails);
    return detailsArray.reduce((total, item) => total + parseFloat(item.qty || 0), 0).toFixed(2);
  } catch (error) {
    console.error('Error parsing table_details:', error);
    return 0;
  }
};
 const handleShow = useCallback(
  async (formData) => {
    const { entry_date_from, entry_date_to } = formData;

    if (!entry_date_from) {
      setError('entry_date_from', { message: 'From Date is required' });
      setDisplayData([]);
      setTotalCount(0);
      return;
    }

    if (!entry_date_to) {
      setError('entry_date_to', { message: 'To Date is required' });
      setDisplayData([]);
      setTotalCount(0);
      return;
    }

    if (dayjs(entry_date_to).isBefore(dayjs(entry_date_from))) {
      setError('entry_date_to', { message: 'To Date cannot be before From Date' });
      setDisplayData([]);
      setTotalCount(0);
      return;
    }

    try {
      setLoading(true);
      setDisplayData([]);

      const filterParams = {
        page,
        size: rowsPerPage,
        searchKey: '',
        fromDate: entry_date_from,
        toDate: entry_date_to,
      };

      const response = await Sales_reportSerivces.getSalesreport(filterParams);
      let fetchedData = response?.data || response || [];
      const total = response?.total_count || fetchedData.length || 0;

      fetchedData = fetchedData.filter((row) => {
        const challanDate = dayjs(row.challan_date);
        if (!challanDate.isValid()) {
          console.warn('Invalid challan_date:', row.challan_date);
          return false;
        }
        const fromDate = dayjs(entry_date_from);
        const toDate = dayjs(entry_date_to).endOf('day');
        return (
          (challanDate.isAfter(fromDate) || challanDate.isSame(fromDate, 'day')) &&
          (challanDate.isBefore(toDate) || challanDate.isSame(toDate, 'day'))
        );
      });

      fetchedData = fetchedData.map((row) => {
        const totalQty = getTotalQtyFromTableDetails(row.table_details);
        const rate = row.rate;
        const basicAmount = (parseFloat(totalQty) * rate).toFixed(2);
        const gstAmount = (basicAmount *0.18).toFixed(2); 
        const totalAmount = (parseFloat(basicAmount) + parseFloat(gstAmount)).toFixed(2);

        return {
          ...row,
          total_qty_from_details: totalQty,
          basic_amount: basicAmount,
          gst_amount: gstAmount,
          total_amount: totalAmount,
        };
      });

      setDisplayData(fetchedData);
      setTotalCount(fetchedData.length);
    } catch (error) {
      console.error('Error fetching data:', error);
      setDisplayData([]);
      setTotalCount(0);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch data. Please try again.';
      setSuccessMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  },
  [setError, page, rowsPerPage]
);
  useEffect(() => {
    if (entryDateFrom && entryDateTo && !errors.entry_date_from && !errors.entry_date_to) {
      handleShow({
        entry_date_from: entryDateFrom,
        entry_date_to: entryDateTo,
      });
    } else {
      setDisplayData([]);
      setTotalCount(0);
      setSuccessMessage('');
    }
  }, [entryDateFrom, entryDateTo, errors, handleShow]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (entryDateFrom && entryDateTo && !errors.entry_date_from && !errors.entry_date_to) {
      handleShow({
        entry_date_from: entryDateFrom,
        entry_date_to: entryDateTo,
      });
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (entryDateFrom && entryDateTo && !errors.entry_date_from && !errors.entry_date_to) {
      handleShow({
        entry_date_from: entryDateFrom,
        entry_date_to: entryDateTo,
      });
    }
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage('');
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDetails = (tableData) => {
    try {
      const parsedData = JSON.parse(tableData);
      setInfo(parsedData);
      setDetail(true);
    } catch (error) {
      console.error('Error parsing tableData:', error);
      setSuccessMessage('Failed to parse details');
    }
  };

  const dateConversion = (date) => {
    if (!date) return '';
    const today = new Date(date);
    if (isNaN(today)) return '';
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const handleClose = () => {
    setDetail(false);
  };

  const getPlantName = (short_code) => {
    const plantData = plant.find((p) => p.short_code === short_code);
    return plantData?.plant_name || short_code || 'Unknown';
  };

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);

    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: 'Sales Report' }]} />
        <Typography className={styles.header_txt}>SALES REPORT</Typography>

        <Grid container spacing={2} className="no-print">
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography className={styles.label_Txt_add}>From Date</Typography>
              <Controller
                name="entry_date_from"
                control={control}
                render={({ field }) => (
                  <CTSRinput
                    size="small"
                    fullWidth
                    type="date"
                    {...field}
                    error={!!errors.entry_date_from}
                    helperText={errors.entry_date_from?.message}
                    InputProps={{ className: styles.CTSinput_Box }}
                  />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography className={styles.label_Txt_add}>To Date</Typography>
              <Controller
                name="entry_date_to"
                control={control}
                render={({ field }) => (
                  <CTSRinput
                    size="small"
                    fullWidth
                    type="date"
                    {...field}
                    error={!!errors.entry_date_to}
                    helperText={errors.entry_date_to?.message}
                    InputProps={{ className: styles.CTSinput_Box }}
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12} sx={{ mt: 4 }}>
          <Paper sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '10px' }}>
              <Button
                variant="outlined"
                startIcon={<Print />}
                onClick={handlePrint}
                disabled={displayData.length === 0}
                className="no-print"
              >
                Print
              </Button>
            </Box>

            <div className="printable-area">
              <div className="print-header-info" style={{ marginBottom: '20px' }}>
                <Typography variant="h5" align="left" sx={{ fontWeight: 'bold' }}>
                  Sales Report
                </Typography>
                <Typography variant="body2" align="left" sx={{ marginTop: 1 }}>
                  From: {entryDateFrom ? dateConversion(entryDateFrom) : ''} &nbsp;&nbsp; | &nbsp;&nbsp; To:{' '}
                  {entryDateTo ? dateConversion(entryDateTo) : ''} &nbsp;&nbsp;
                </Typography>
              </div>
              <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Sr No</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Date</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Customer</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Product</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Qty</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Rate</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Basic Amt</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>GST</StyledTableCell>
                                            <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Total Amt</StyledTableCell>
                     
                    </StyledTableRow>
                  </TableHead>

              <TableBody sx={{ backgroundColor: '#fff' }}>
  {loading ? (
    <StyledTableRow>
      <StyledTableCell colSpan={10} align="center">
        <Typography>Loading data...</Typography>
      </StyledTableCell>
    </StyledTableRow>
  ) : displayData.length === 0 ? (
    <StyledTableRow>
      <StyledTableCell colSpan={10} align="center">
        <Typography>No data found</Typography>
      </StyledTableCell>
    </StyledTableRow>
  ) : (
    displayData.map((row, index) => (
      <StyledTableRow key={index}>
        <StyledTableCell align="left">{page * rowsPerPage + index + 1}</StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>
          {dateConversion(row.challan_date)}
        </StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>{row.cust_name}</StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>{row.prod_code}</StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>
          {row.total_qty_from_details}
        </StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>
          {(row.rate !== null ? Number(row.rate).toFixed(2) : '0.00')}

        </StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>
          {row.basic_amount !== 'NaN' ? row.basic_amount : '0.00'}
        </StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>
          {row.gst_amount !== 'NaN' ? row.gst_amount : '0.00'}%
        </StyledTableCell>
        <StyledTableCell align="left" className={styles.inspection_cell}>
          {row.total_amount !== 'NaN' ? row.total_amount : '0.00'}
        </StyledTableCell>
       
      </StyledTableRow>
    ))
  )}
</TableBody>
                </Table>
              </TableContainer>
            </div>

            <TablePagination
              className="no-print"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={() => setSuccessMessage('')}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
          className="no-print"
        />

        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="image-modal-title"
          aria-describedby="image-modal-description"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          className="no-print"
        >
          <Box
            sx={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <IconButton
              sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
              onClick={handleCloseModal}
              aria-label="Close image modal"
            >
              <CloseIcon />
            </IconButton>
            <img
              src={selectedImage}
              alt="Full-size receipt"
              style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
              onError={(e) => {
                e.target.onerror = null;
              }}
            />
          </Box>
        </Modal>

        <BootstrapDialog
          PaperProps={{
            sx: {
              minWidth: '90%',
              maxHeight: '90%',
            },
          }}
          onClose={handleClose}
          open={openDetail}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            Details
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
              <Table size="small" stickyHeader className="printable-table">
                <TableHead className={styles.table_head_container}>
                  <StyledTableRow>
                    <StyledTableCell align="center">Sr No</StyledTableCell>
                    <StyledTableCell align="left">Cylinder No</StyledTableCell>
                    <StyledTableCell align="left">Tag No</StyledTableCell>
      
                  </StyledTableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: '#fff' }}>
                  {info.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell align="center">{row.sr_no}</StyledTableCell>
                      <StyledTableCell className={styles.inspection_cell}>{row.cyl_no}</StyledTableCell>
                      <StyledTableCell className={styles.inspection_cell}>{row.tag_no}</StyledTableCell>
                     
                      
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </BootstrapDialog>
      </Box>
    </Box>
  );
};

export default Salesreport;